// extracted by mini-css-extract-plugin
export default {"item":"EventItem_item__S4dv7","label":"EventItem_label__VfwIu"};